import { jsx as _jsx } from "react/jsx-runtime";
export const SectionCard = ({ children }) => {
    return _jsx("div", { className: 'rounded-md border border-solid border-neutral-300 bg-white', children: children });
};
